module.exports = __webpack_public_path__ + "static/media/note-board.dc511a74.svg";